import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Loader2, Printer } from "lucide-react";
import { QRCodeSVG } from "qrcode.react";
import { api } from "../api";

const QR_BASE = process.env.REACT_APP_BACKEND_URL || "";

export default function PrintMuseum() {
  const { id } = useParams();
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!id) return;
    api.getMuseum(id).then(setData).catch(() => {});
  }, [id]);

  if (!data) return <div className="min-h-screen flex items-center justify-center"><Loader2 className="animate-spin text-brand" /></div>;

  return (
    <div className="min-h-screen bg-white">
      <div className="no-print bg-bg border-b border-border p-4 flex items-center justify-between max-w-3xl mx-auto">
        <div className="text-sm text-ink-soft">{data.artworks.length} cartelli A6 · {data.museum.name}</div>
        <button onClick={() => window.print()} className="inline-flex items-center gap-2 bg-brand text-white px-4 py-2 rounded-full text-sm font-semibold hover:bg-brand-hover">
          <Printer size={16} /> Stampa tutto
        </button>
      </div>
      {data.artworks.map((a) => {
        const url = `${QR_BASE}/q/${a.qr_code}`;
        return (
          <div key={a.id} className="print-page max-w-md mx-auto p-8">
            <div className="border-2 border-ink rounded-2xl p-6 text-center">
              <div className="text-[11px] tracking-[0.4em] font-semibold text-brand mb-2">QRTOURIST</div>
              <h1 className="font-heading font-bold text-3xl text-ink leading-tight">{a.title}</h1>
              <div className="text-sm text-ink-soft mt-1">{a.artist} · {a.year}</div>
              <div className="flex justify-center my-6">
                <QRCodeSVG value={url} size={220} fgColor="#0B4A99" level="H" includeMargin />
              </div>
              <div className="text-xs text-ink-soft">Inquadra con la fotocamera</div>
              <div className="font-mono text-xs text-ink mt-2">{a.qr_code}</div>
              <div className="text-[10px] text-ink-soft mt-4 tracking-wider">{data.museum.name?.toUpperCase()}</div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
